export enum EmbedSource {
  YouTube = 'YouTube',
  Staige = 'Staige',
  Sporttotal = 'Sporttotal',
  oneFootball = 'oneFootball',
}
